import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";
import classes from "./MenuItem.css";
import {
  modalStatusToggle,
  mobileLogin,
  RequestForRefundList
} from "../../../store/action/index";
import globalcss from "../../../global.css";

class MenuItem extends Component {
  LogOut = () => {
    localStorage.removeItem("CELL_PHONE");
    localStorage.removeItem("LOG_IN_WITH_PHONE");
    this.props.mobileLogin();
    this.props.RequestForRefundList();
  };

  render() {
    return (
      <div className={classes.menuContainer}>
        <ul>
          <li>
            <NavLink to="/sign">درخواست SIGN</NavLink>
          </li>
          <li>
            <NavLink to="/">استرداد آنلاین</NavLink>
          </li>
          <li>
            {this.props.loginwithMobile ? (
              <button
                onClick={this.LogOut}
                className={[globalcss.button, classes.LoginButton].join(" ")}
              >
                {localStorage["CELL_PHONE"]}
                <span className={classes.LogoutIcon}></span>
              </button>
            ) : (
              <button
                onClick={() => this.props.modalStatusToggle("MOBILE")}
                className={[globalcss.button, classes.LoginButton].join(" ")}
              >
                ورود با شماره همراه
              </button>
            )}
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginwithMobile: state.MOBILE.loginwithMobile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    modalStatusToggle: value => dispatch(modalStatusToggle(value)),
    mobileLogin: () => dispatch(mobileLogin()),
    RequestForRefundList: () => dispatch(RequestForRefundList())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MenuItem)
);
